const ProtectedResource = () => {
  return (
    <section>
      <a href="/">Go back</a>
      <p>Protected resource is only visible after sign-in.</p>
    </section>
  );
};

export default ProtectedResource;
